import { render } from "./IndexerForm.vue?vue&type=template&id=b9acef46&scoped=true"
import script from "./IndexerForm.vue?vue&type=script&lang=js"
export * from "./IndexerForm.vue?vue&type=script&lang=js"

import "./IndexerForm.vue?vue&type=style&index=0&id=b9acef46&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9acef46"]])

export default __exports__